import { useState } from "react";
import AwaitingApproval from "./components/AwaitingApproval";
import ConsentForm from "./components/ConsentForm";

const KemWaitingApprovalPage = () => {
  const [isConsentForm, setIsConsentForm] = useState(false);

  return (
    <div className="flex h-full w-full items-center justify-center">
      {isConsentForm ? (
        <ConsentForm onSuccess={() => setIsConsentForm(false)} />
      ) : (
        <AwaitingApproval />
      )}
    </div>
  );
};

export default KemWaitingApprovalPage;
